Vue.prototype.$first = function (item, list) {
    return item === list[0]
};
var vmedict = new Vue({
    el: "#vue-edict",
    data: {
        years: null,
        months: null,
        days: null,
        selectedYear: "",
        selectedMonth: "",
        selectedDay: "",
    },
    mounted: function () {
        epicaAddEventClick('#vue-edict');
    },
    methods: {
        getYears: function () {
            this.$http.get('/api/edict/').then(function (response) {
                this.years = response.body;
            }, function (response) {

            });
        },
        getMonths: function () {
            if (this.selectedYear) {
                this.$http.get('/api/edict/' + this.selectedYear).then(function (response) {
                    this.months = response.body;
                }, function (response) {

                });
            }
            else {
                this.selectedMonth = "";
                this.selectedDay = "";
            }
        },
        getDays: function () {
            if (this.selectedMonth) {
                this.$http.get('/api/edict/' + this.selectedYear + '/' + this.selectedMonth).then(function (response) {
                    this.days = response.body;
                }, function (response) {

                });
            }
            else {
                this.selectedDay = "";
            }
        },
        goToEdict: function () {
            window.location.href = "/edictos-impreso/" + this.selectedYear + "/" + this.selectedMonth + "/" + this.selectedDay;
        }
    }
});
vmedict.getYears();

//var vmedict2 = new Vue({
//    el: "#vue-edict-2", 
//    data: {
//        years: null,
//        months: null,
//        days: null,
//        selectedYear: "",
//        selectedMonth: "",
//        selectedDay: "",
//    },
//    methods: {
//        getYears: function () {
//            this.$http.get('/api/edict/').then(function (response) {
//                this.years = response.body;
//            }, function (response) {

//            });
//        },
//        getMonths: function () {
//            if (this.selectedYear) {
//                this.$http.get('/api/edict/' + this.selectedYear).then(function (response) {
//                    this.months = response.body;
//                }, function (response) {

//                });
//            }
//            else {
//                this.selectedMonth = "";
//                this.selectedDay = "";
//            }
//        },
//        getDays: function () {
//            if (this.selectedMonth) {
//                this.$http.get('/api/edict/' + this.selectedYear + '/' + this.selectedMonth).then(function (response) {
//                    this.days = response.body;
//                }, function (response) {

//                });
//            }
//            else {
//                this.selectedDay = "";
//            }
//        },
//        goToEdict: function () {
//            window.location.href = "/asuntos-legales/edictos/" + this.selectedYear + "/" + this.selectedMonth + "/" + this.selectedDay;
//        }
//    }
//});
//vmedict2.getYears();